import type { Maybe } from '@xing-com/crate-common-graphql-types';
import type {
  JobMatchingHighlightsV2Fragment,
  JobTeaserData,
} from '@xing-com/crate-jobs-graphql';
import type { NwtTrackingProps } from '@xing-com/crate-jobs-tracking';

import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

import { JobTeaserListItemSkeleton } from './job-teaser-list-item-skeleton';

export type JobTeaserListItemProps = {
  job: JobTeaserData;
  isNew?: boolean;
  url?: string;
  highlight?: string | null;
  matchingHighlights?: Maybe<JobMatchingHighlightsV2Fragment>;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onContextMenu?: () => void;
  onAuxClick?: () => void;
  actions?: React.ReactElement;
  className?: string;
  'data-testid'?: string;
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  showEmploymentType?: boolean;
  showApplyButton?: boolean;
  showAISummary?: boolean;
  'aria-label'?: string;
  isUrgentJob?: boolean;
  applyTrackingProps?: NwtTrackingProps;
};

export type JobTeaserListItemXinglet = XingletInterface<JobTeaserListItemProps>;

export const JobTeaserListItem = JobsXingletWrapper<JobTeaserListItemProps>(
  '@xing-com/crate-jobs-components-job-teaser-list-item',
  <JobTeaserListItemSkeleton />
);
